import { render, staticRenderFns } from "./SchoolProfile.vue?vue&type=template&id=4e4c143e&scoped=true&"
import script from "./SchoolProfile.vue?vue&type=script&lang=js&"
export * from "./SchoolProfile.vue?vue&type=script&lang=js&"
import style0 from "./SchoolProfile.vue?vue&type=style&index=0&id=4e4c143e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c143e",
  null
  
)

export default component.exports